export default __webpack_public_path__ + "static/media/BARRA_PRR_MONO_2024-02.d0a60dc0.png";